import { Area, Section } from "./fields";

export const emptyGtyIntake = { anything_else: "", guided_answers: {} };

export const INTAKE_GTY_QUESTIONS = [
  { id: "intake_gty_day", text: "What does a good day look like for the client?" },
  { id: "intake_gty_food", text: "Favorite foods — and any foods to avoid?" },
  { id: "intake_gty_routine", text: "Daily routines that matter (morning rituals, TV shows, nap times, faith practices)?" },
  { id: "intake_gty_interests", text: "Hobbies, interests, or topics they love to talk about?" },
  { id: "intake_gty_upsets", text: "Is there anything that upsets, worries, or frustrates them?" },
  { id: "intake_gty_people", text: "Important people, pets, or traditions in their life?" },
  { id: "intake_gty_communication", text: "How do they communicate best? Any hearing, vision, or language needs?" },
];

export default function GtyIntakeForm({ data, onChange }) {
  const guided = data.guided_answers || {};
  const setA = (q) => (e) => onChange({ ...data, guided_answers: { ...guided, [q.id]: { question: q.text, answer: e.target.value } } });
  const setElse = (e) => onChange({ ...data, anything_else: e.target.value });
  return (
    <div className="space-y-6" data-testid="gty-intake-form">
      <Section title="Getting to know the client"
        desc="These answers help us match the right caregiver and make visits feel personal, not clinical. Answer what you can — skip what doesn't apply.">
        {INTAKE_GTY_QUESTIONS.map((q) => (
          <div key={q.id} className="md:col-span-2">
            <Area label={q.text} tid={`gty-intake-${q.id}`} value={guided[q.id]?.answer || ""} onChange={setA(q)} />
          </div>
        ))}
        <div className="md:col-span-2">
          <Area label="Anything else you'd like us to know?" tid="gty-intake-anything-else" value={data.anything_else || ""} onChange={setElse} />
        </div>
      </Section>
    </div>
  );
}
